import { Header } from "../../../../src/components/common/header";
import { PrivacyPolicy } from "../../../../src/components/privacy-policy";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  Header,
  PrivacyPolicy,
  Footer,
  React
};